import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aa2d09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Estado Año 2022")
], -1))
const _hoisted_3 = { class: "table table-hover" }
const _hoisted_4 = { style: {"cursor":"pointer"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Facturado", -1))
const _hoisted_6 = { class: "bold der blue" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { style: {"cursor":"pointer"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Pagado", -1))
const _hoisted_10 = { class: "bold der orange" }
const _hoisted_11 = { style: {"cursor":"pointer"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Retención", -1))
const _hoisted_13 = { class: "bold der red" }
const _hoisted_14 = { style: {"cursor":"pointer"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Ingresos", -1))
const _hoisted_16 = { class: "bold der green" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"cursor":"pointer"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Reenviado", -1))
const _hoisted_20 = { class: "bold der blue" }
const _hoisted_21 = { style: {"cursor":"pointer"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Recuperado", -1))
const _hoisted_23 = { class: "bold der green" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { style: {"cursor":"pointer"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Por Cobrar", -1))
const _hoisted_27 = { class: "bold der blue" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { style: {"cursor":"pointer"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq" }, "Glosa", -1))
const _hoisted_31 = { class: "bold der grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _hoisted_2,
        _createElementVNode("table", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.medicos, (medico, index) => {
            return (_openBlock(), _createElementBlock("tbody", { key: index }, [
              _createElementVNode("tr", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("td", _hoisted_6, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.facturado)), 1)
              ]),
              _hoisted_7,
              _createElementVNode("tr", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("td", _hoisted_10, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.pagado)), 1)
              ]),
              _createElementVNode("tr", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.retension)), 1)
              ]),
              _createElementVNode("tr", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("td", _hoisted_16, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.ingresos)), 1)
              ]),
              _hoisted_17,
              _createElementVNode("tr", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("td", _hoisted_20, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.reenviado)), 1)
              ]),
              _createElementVNode("tr", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.recuperado)), 1)
              ]),
              _hoisted_24,
              _createElementVNode("tr", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("td", _hoisted_27, " RD$ " + _toDisplayString($options.formatNumber(medico.estado.porCobrar)), 1)
              ]),
              _hoisted_28,
              _createElementVNode("tr", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("td", _hoisted_31, "RD$ " + _toDisplayString($options.formatNumber(medico.estado.glosa)), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}